import { render, staticRenderFns } from "./NoticeOfUsageSB.vue?vue&type=template&id=6df16dcf&scoped=true&"
import script from "./NoticeOfUsageSB.vue?vue&type=script&lang=js&"
export * from "./NoticeOfUsageSB.vue?vue&type=script&lang=js&"
import style0 from "./NoticeOfUsageSB.vue?vue&type=style&index=0&id=6df16dcf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df16dcf",
  null
  
)

export default component.exports